import React, { SyntheticEvent, useState } from 'react';
import { Button, Form, Col, DatePicker, Input } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import moment from 'moment';
import DateFilterQueryParams from 'src/types/DateFilterQueryParams';
import UserContex from 'src/services/UserContex';
import useQueryUrlParamsDispatch from 'src/hooks/useQueryUrlParamsDispatch';
import styles from './DateFilterForm.module.less';

export type DateFilterFormProps = FormComponentProps & {
  visible: boolean;
  values?: DateFilterQueryParams;
  createdStartDefault: string;
  createdEndDefault: string;
  finishedStartDefault: string;
  finishedEndDefault: string;
  ownerName: string;
  onSubmit: (values?: any) => void;
};

export const DateFilterForm: React.FC<DateFilterFormProps> = ({
  form,
  createdStartDefault,
  onSubmit,
}: DateFilterFormProps) => {
  const { getFieldDecorator } = form;
  const dateFormat = UserContex.getDateFormat() ?? 'MM-DD-YY';
  const bAdminMode = localStorage.getItem('bAdminMode') === 'true';
  const [createdStartsUpdate, setCreatedStartsUpdate] = useState(createdStartDefault);
  const [createdEndsUpdate, setCreatedEndsUpdate] = useState(null);
  const [finishedStartsUpdate, setFinishedStartsUpdate] = useState(null);
  const [finishedEndsUpdate, setFinishedEndsUpdate] = useState(null);
  function handleCreatedStarts(_: unused, dateString: string) {
    setCreatedStartsUpdate(dateString);
  }
  function handleCreatedEnds(_: unused, dateString: any) {
    setCreatedEndsUpdate(dateString);
    setCreatedStartsUpdate(createdStartDefault);
  }
  function handleFinishedStarts(_: unused, dateString: any) {
    setFinishedStartsUpdate(dateString);
    setCreatedStartsUpdate(createdStartDefault);
  }
  function handleFinishedEnds(_: unused, dateString: any) {
    setFinishedEndsUpdate(dateString);
    setCreatedStartsUpdate(createdStartDefault);
  }

  const handleSubmit = (event: SyntheticEvent): boolean => {
    event.preventDefault();
    form.validateFields((err, values: DateFilterQueryParams) => {
      if (!err) {
        values.createdStart = createdStartsUpdate;
        if (createdStartsUpdate !== undefined) {
          values.createdStart = createdStartsUpdate;
        }
        if (createdEndsUpdate !== undefined) {
          values.createdEnd = createdEndsUpdate;
        }
        if (finishedStartsUpdate !== undefined) {
          values.finishedStart = finishedStartsUpdate;
        }
        if (finishedEndsUpdate !== undefined) {
          values.finishedEnd = finishedEndsUpdate;
        }
        if (onSubmit) {
          onSubmit(values);
        }
      }
    });
    return false;
  };

  const setQuery = useQueryUrlParamsDispatch<DateFilterQueryParams>();
  const handleClearButton = (values: any) => {
    setCreatedEndsUpdate(null);
    setFinishedEndsUpdate(null);
    setFinishedStartsUpdate(null);
    setCreatedStartsUpdate(createdStartDefault);
    setQuery({
      createdStart: values.createdStart,
      createdEnd: values.createdEnd,
      finishedStart: values.finishedStart,
      finishedEnd: values.finishedEnd,
      ownerName: values.ownerName,
    });
    return form.resetFields();
  };

  return (
    <Form onSubmit={handleSubmit} className={styles.form}>
      <Col span={12}>
        <Form.Item label="Started" className={styles.formItem}>
          {getFieldDecorator('createdStart', {
            initialValue: moment(createdStartDefault ?? createdStartsUpdate, dateFormat),
          })(
            <DatePicker
              showTime={false}
              showToday={false}
              placeholder="Created Start"
              onChange={handleCreatedStarts}
              format={dateFormat}
              style={{ width: '130px', minWidth: 'auto' }}
            />
          )}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item label="thru" className={styles.formItem}>
          {getFieldDecorator('createdEnd')(
            <DatePicker
              showTime={false}
              showToday={false}
              name="createdEnd"
              placeholder="thru"
              onChange={handleCreatedEnds}
              format={dateFormat}
              style={{ width: '130px', minWidth: 'auto' }}
            />
          )}
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item label="Finished" className={styles.formItem}>
          {getFieldDecorator('finishedStart')(
            <DatePicker
              showTime={false}
              showToday={false}
              name="finishedStart"
              placeholder="Finished"
              onChange={handleFinishedStarts}
              format={dateFormat}
              style={{ width: '130px', minWidth: 'auto' }}
            />
          )}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item label="thru" className={styles.formItem}>
          {getFieldDecorator('finishedEnd')(
            <DatePicker
              showTime={false}
              showToday={false}
              name="finishedEnd"
              placeholder="thru"
              onChange={handleFinishedEnds}
              format={dateFormat}
              style={{ width: '130px', minWidth: 'auto' }}
            />
          )}
        </Form.Item>
      </Col>
      {bAdminMode && (
        <Form.Item label="Owner" className={styles.formItem}>
          {getFieldDecorator('ownerName')(
            <Input placeholder="owner Name" style={{ width: '130px', minWidth: 'auto' }} />
          )}
        </Form.Item>
      )}
      <Form.Item
        className={styles.form_buttons_bar}
        style={{
          clear: 'both',
          display: 'block',
          lineHeight: '100%',
          margin: '0px',
          padding: '0px',
        }}
      >
        <Button className={styles.clear_button} onClick={handleClearButton}>
          Clear
        </Button>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

const WrappedDateFilterForm = Form.create<DateFilterFormProps>({ name: 'dateFilter' })(DateFilterForm);
export default WrappedDateFilterForm;
